import store from '@/store';
import { modalController } from '@ionic/vue';
import OwnerPinVerifyModal from '@/components/Profile/OwnerPinVerifyModal.vue';
import { isLoginRoute } from '@/utils/authUtils';
const FULLSCREEN_MODAL_CLASS = 'fullscreen-modal';

export const requireOwnerPin = async () => {
  if (store.getters['ownerPin/isOwnerPinVerified']) {
    return true;
  }

  let statusResponse = await store.dispatch('profile/fetchOwnerPinStatus');
  if (statusResponse?.status !== 200) {
    statusResponse = await store.dispatch('profile/fetchOwnerPinStatus');
  }
  const status = store.getters['profile/ownerPinStatus'];
  const statusKnown = store.getters['profile/ownerPinStatusKnown'];

  let pinRequired = false;
  if (statusResponse?.status === 200) {
    pinRequired = Boolean(status?.enabled);
  } else if (statusKnown && status?.enabled) {
    pinRequired = true;
  } else if (!statusKnown) {
    pinRequired = true;
  }

  if (!pinRequired) {
    return true;
  }

  store.commit('ui/incrementOverlay');
  const modal = await modalController.create({
    component: OwnerPinVerifyModal,
    cssClass: FULLSCREEN_MODAL_CLASS,
    backdropDismiss: true,
    canDismiss: async (_data, role) => (
      role === 'gesture'
      || role === 'backdrop'
      || role === 'cancel'
      || role === 'verified'
      || role === 'not_required'
    ),
  });
  try {
    await modal.present();
    const { role, data } = await modal.onDidDismiss();

    if (role === 'verified' && data?.verifiedUntil) {
      store.commit('ownerPin/SET_VERIFIED_UNTIL', data.verifiedUntil);
      return true;
    }
    if (role === 'not_required' && data?.notRequired) {
      return true;
    }
    return false;
  } finally {
    store.commit('ui/decrementOverlay');
  }
};

export const checkOwnerPinRoute = async (to, from, next) => {
  if (!to.meta?.requiresOwnerPin) {
    next();
    return;
  }
  const ok = await requireOwnerPin();
  if (ok) {
    next();
    return;
  }
  if (!from?.name || isLoginRoute(from)) {
    next({ name: 'navigation.profile', replace: true });
    return;
  }
  next(false);
};
